export enum SentimentEnum {
    Negative = -1,
    Positive = 1,
}
